module.exports = __webpack_public_path__ + "media/common/interview-feature3-33a73894.svg";